export const fileSize = (size: number) => {
    const i = size === 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024));
    return (size / Math.pow(1024, i)).toFixed(2) + ' ' + ['Б', 'КБ', 'МБ', 'ГБ', 'ТБ'][i];
}
